import { SVGProps } from 'react';

const SvgNotesMedical = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M144 96c0-8.8 7.2-16 16-16h256c8.8 0 16 7.2 16 16v197.5c0 4.2-1.7 8.3-4.7 11.3l-58.5 58.5c-3 3-7.1 4.7-11.3 4.7H160c-8.8 0-16-7.2-16-16V96zm-48 0v256c0 35.3 28.7 64 64 64h197.5c17 0 33.3-6.7 45.3-18.7l58.5-58.5c12-12 18.7-28.3 18.7-45.3V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zm176 32c-8.8 0-16 7.2-16 16v48h-48c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h48v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h48c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16h-48v-48c0-8.8-7.2-16-16-16h-32zm24 336H136c-48.6 0-88-39.4-88-88V152c0-13.3-10.7-24-24-24S0 138.7 0 152v224c0 75.1 60.9 136 136 136h160c13.3 0 24-10.7 24-24s-10.7-24-24-24z" />
  </svg>
);
export default SvgNotesMedical;
